<template>
  <div class="location-price">
    <div class="label f8">{{ label }}</div>
    <div class="amount f2">{{ toLocationLocale(amount) }}</div>
    <div class="taxrow"  :class="darkMode ? 'dark' : ''" v-if="amount > 0 && tax">
      <div class="taxes f8">{{ tax }} {{ $t('tax') }}</div>
      <MoreInfoTooltip>
        <i18n tag="p" class="f8" path="Tax shown here are based on the location's current tax rate, and are not meant for accounting purposes. {bookingExport}">
          <a class="link-style" slot="bookingExport" target="_blank" href="https://svr.li/k/283">{{ $t('Use our Reservation Export to get transaction based data.') }}</a>
        </i18n>
      </MoreInfoTooltip>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import MoreInfoTooltip from '@/core/shared/components/MoreInfoTooltip';

@Component({
  components: {
    MoreInfoTooltip,
  },
  props: {
    locationId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
})
export default class LocationPrice extends Vue {
  get tax () {
    const beforeTax = Math.round(this.amount / (this.taxAmount / 100 + 1));
    const tax = this.amount - beforeTax;

    return `${this.toLocationLocale(beforeTax)} + ${this.toLocationLocale(tax)}`;
  }

  get taxAmount () {
    if (this.$store) {
      return this.$store.getters['entities/Location'](this.locationId).taxAmount;
    }
  }

  toLocationLocale (number) {
    if (this.$store) {
      return this.$store.getters.formatAsLocationCurrency({ locationId: this.locationId, number });
    }
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.location-price {
  & .label {
    margin-bottom: var(--spacingXS);
    color: var(--colorManatee);
  }

  & .amount {
    margin-bottom: var(--spacingXS);
  }

  & .taxes {
    margin-bottom: var(--spacingXS);
  }

  & .taxrow {
    display: flex;
    align-items: center;

    & >>> .more-info-tooltip .hover {
      position: relative;
      top: -0.3rem;
      margin-left: var(--spacingXS);
    }

    & >>> .more-info-tooltip .popup {
      left: 1.5rem;
      z-index: 2;
    }
  }
}

.taxrow.dark .taxes {
  color: var(--darkModeColorText);
}
</style>
